/**
 * Generated by orval v7.17.2 🍺
 * Do not edit manually.
 * FacilityFlow API
 * Eine professionelle Web API für Facility Management mit Versionierung, Logging und Observability.
 * OpenAPI spec version: 1.0
 */
import type {
  FacilityFlowCoreModulesServicesDtosApplyPriceIndexRequest,
  FacilityFlowCoreModulesServicesDtosApplyPriceIndexResponse,
  FacilityFlowCoreModulesServicesDtosCreatePriceIndexRequest,
  FacilityFlowCoreModulesServicesDtosCreatePriceIndexResponse,
  FacilityFlowCoreModulesServicesDtosPriceIndexDto,
  FacilityFlowCoreModulesServicesDtosPriceIndexListDto
} from '.././models';

import { customInstance } from '../../mutator/custom-instance';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  export const getPriceIndexes = () => {
/**
 * @summary Create a new price index
 */
const postApiV1PriceIndexes = (
    facilityFlowCoreModulesServicesDtosCreatePriceIndexRequest: FacilityFlowCoreModulesServicesDtosCreatePriceIndexRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesServicesDtosCreatePriceIndexResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesServicesDtosCreatePriceIndexResponse>(
      {url: `/api/v1/price-indexes`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesServicesDtosCreatePriceIndexRequest
    },
      options);
    }
  /**
 * @summary Get all price indexes
 */
const getApiV1PriceIndexes = (
    
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesServicesDtosPriceIndexListDto[]>>,) => {
      return customInstance<FacilityFlowCoreModulesServicesDtosPriceIndexListDto[]>(
      {url: `/api/v1/price-indexes`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Get the currently active price index
 */
const getApiV1PriceIndexesActive = (
    
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesServicesDtosPriceIndexDto>>,) => {
      return customInstance<FacilityFlowCoreModulesServicesDtosPriceIndexDto>(
      {url: `/api/v1/price-indexes/active`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Get price index by ID
 */
const getApiV1PriceIndexesId = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesServicesDtosPriceIndexDto>>,) => {
      return customInstance<FacilityFlowCoreModulesServicesDtosPriceIndexDto>(
      {url: `/api/v1/price-indexes/${id}`, method: 'GET'
    },
      options);
    }
  /**
 * @summary Apply a price index (or preview the changes)
 */
const postApiV1PriceIndexesIdApply = (
    id: string,
    facilityFlowCoreModulesServicesDtosApplyPriceIndexRequest: FacilityFlowCoreModulesServicesDtosApplyPriceIndexRequest,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesServicesDtosApplyPriceIndexResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesServicesDtosApplyPriceIndexResponse>(
      {url: `/api/v1/price-indexes/${id}/apply`, method: 'POST',
      headers: {'Content-Type': 'application/json; version=1.0', },
      data: facilityFlowCoreModulesServicesDtosApplyPriceIndexRequest
    },
      options);
    }
  /**
 * @summary Preview price index changes without applying them
 */
const getApiV1PriceIndexesIdPreview = (
    id: string,
 options?: SecondParameter<typeof customInstance<FacilityFlowCoreModulesServicesDtosApplyPriceIndexResponse>>,) => {
      return customInstance<FacilityFlowCoreModulesServicesDtosApplyPriceIndexResponse>(
      {url: `/api/v1/price-indexes/${id}/preview`, method: 'GET'
    },
      options);
    }
  return {postApiV1PriceIndexes,getApiV1PriceIndexes,getApiV1PriceIndexesActive,getApiV1PriceIndexesId,postApiV1PriceIndexesIdApply,getApiV1PriceIndexesIdPreview}};
export type PostApiV1PriceIndexesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPriceIndexes>['postApiV1PriceIndexes']>>>
export type GetApiV1PriceIndexesResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPriceIndexes>['getApiV1PriceIndexes']>>>
export type GetApiV1PriceIndexesActiveResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPriceIndexes>['getApiV1PriceIndexesActive']>>>
export type GetApiV1PriceIndexesIdResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPriceIndexes>['getApiV1PriceIndexesId']>>>
export type PostApiV1PriceIndexesIdApplyResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPriceIndexes>['postApiV1PriceIndexesIdApply']>>>
export type GetApiV1PriceIndexesIdPreviewResult = NonNullable<Awaited<ReturnType<ReturnType<typeof getPriceIndexes>['getApiV1PriceIndexesIdPreview']>>>
